import React, { ChangeEvent, FormEvent, KeyboardEvent } from "react";
import withTitle from "../withTitle";

import "../../form.css";
import { V2 } from "../../Api";
import { formatDateLocalNumeric, formatName, formatPhone } from "../../Utilities";
import { RouteComponentPropsHistory } from "../../types";

interface IPatientSearchViewProps extends RouteComponentPropsHistory<any, any> {

}

interface IPatientSearchInnerProps {
    onPatientSelected?: (id: string, data: any) => void;
}

interface IPatientSearchInnerState {
    isLoading: boolean | string;

    nameLast: string;
    nameFirst: string;
    nameMiddle: string;
    birthdate: string;
    patientId: string;
    phoneNumber: string;
    emailAddress: string;

    results: any[];
}

const PatientSearchView: React.FC<IPatientSearchViewProps> = function (props) {
    const handlePatientSelection = (id: string) => {
        console.log(props.location.state?.action);
        switch (props.location.state?.action) {
            case "create_surgery_from_appointment":
                props.history.push("/surgery/create", { patientId: id, appointmentId: props.location.state?.data.appointmentId });
                break;
            case "create_surgery_from_search":
                props.history.push("/surgery/create", { patientId: id });
                break;
            default:
                props.history.push(`/patient/${id}`);
                break;
        }
    }

    return <div className="viewer-root">
        <PatientSearchInner onPatientSelected={handlePatientSelection} />
    </div>;
}

export class PatientSearchInner extends React.Component<IPatientSearchInnerProps, IPatientSearchInnerState> {
    private _tableRef: React.RefObject<HTMLTableElement> = React.createRef();

    constructor(props: Readonly<IPatientSearchInnerProps>) {
        super(props);

        this.state = {
            isLoading: false,

            nameLast: "",
            nameFirst: "",
            nameMiddle: "",
            birthdate: "",
            patientId: "",
            phoneNumber: "",
            emailAddress: "",

            results: [],
        };

        this.formInputChanged = this.formInputChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clearSearchParameters = this.clearSearchParameters.bind(this);
    }

    public render() {
        return <form className="input-form" onSubmit={this.handleSubmit} autoComplete="off">
            <section className="info-block">
                <header>
                    <h2>Search Parameters</h2>
                </header>

                <section>
                    <div className="input-form-group">
                        <label htmlFor="frm-name-last">Last Name</label>
                        <input type="text" id="frm-name-last" name="nameLast" value={this.state.nameLast} onChange={this.formInputChanged} autoFocus={true} />
                    </div>
                    <div className="input-form-group">
                        <label htmlFor="frm-name-first">First Name</label>
                        <input type="text" id="frm-name-first" name="nameFirst" value={this.state.nameFirst} onChange={this.formInputChanged} />
                    </div>
                    <div className="input-form-group">
                        <label htmlFor="frm-name-middle">Middle Name</label>
                        <input type="text" id="frm-name-middle" name="nameMiddle" value={this.state.nameMiddle} onChange={this.formInputChanged} />
                    </div>
                    <div className="input-form-group">
                        <label htmlFor="frm-birthdate">Birthdate</label>
                        <input type="date" id="frm-birthdate" name="birthdate" value={this.state.birthdate} onChange={this.formInputChanged} />
                    </div>
                </section>
                <section>
                    <div className="input-form-group">
                        <label htmlFor="frm-patient-id">Patient ID</label>
                        <input type="text" id="frm-patient-id" name="patientId" value={this.state.patientId} onChange={this.formInputChanged} />
                    </div>
                    <div className="input-form-group">
                        <label htmlFor="frm-phone-number">Phone Number</label>
                        <input type="text" id="frm-phone-number" name="phoneNumber" value={this.state.phoneNumber} onChange={this.formInputChanged} />
                    </div>
                    <div className="input-form-group">
                        <label htmlFor="frm-email-address">Email Address</label>
                        <input type="text" id="frm-email-address" name="emailAddress" value={this.state.emailAddress} onChange={this.formInputChanged} />
                    </div>
                    <div className="input-form-group"></div>
                </section>
                &nbsp;
                <div className="action-panel-dialog">
                    <button type="submit" className="button text-with-icon"><i className="icon-search" /><span>Search</span></button>
                    <button type="button" className="button text-with-icon" onClick={this.clearSearchParameters}><i className="icon-times" /><span>Clear</span></button>
                </div>
            </section>
            &nbsp;
            {this.state.isLoading === true
                ? <div className="spinner lds-dual-ring" />
                : typeof this.state.isLoading === "string"
                    ? <div className="error-text">{this.state.isLoading}</div>
                    : this.state.results.length === 0
                        ? <p>No results</p>
                        : <table className="table-vertical" ref={this._tableRef}>
                            <thead>
                                <tr>
                                    <th>Patient ID</th>
                                    <th>Name</th>
                                    <th className="col-smallest">Sex</th>
                                    <th>Birthdate</th>
                                    <th>Phone #</th>
                                    <th>Email Address</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.results.map(a => <tr key={a.id} className="clickable" tabIndex={0} onClick={() => this.selectPatient(a.id)} onKeyDown={this.handleRowKeydown}>
                                    <td>{a.patientId}</td>
                                    <td>{formatName(a.name)}</td>
                                    <td>{a.sex}</td>
                                    <td>{formatDateLocalNumeric(a.birthdate)}</td>
                                    <td>{formatPhone(a.phoneNumber)}</td>
                                    <td>{a.emailAddress}</td>
                                </tr>)}
                            </tbody>
                        </table>
            }
        </form>;
    }

    private formInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>) {
        const name = e.currentTarget.name;
        const value = (e.currentTarget.type === "checkbox") ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }

    private async handleSubmit(e: FormEvent) {
        e.preventDefault();

        const data = {
            lastName: this.state.nameLast,
            firstName: this.state.nameFirst,
            middleName: this.state.nameMiddle,
            birthDate: this.state.birthdate,
            patientId: this.state.patientId,
            phoneNumber: this.state.phoneNumber,
            emailAddress: this.state.emailAddress,
            offset: 0,
            limit: 10,
        };

        // Remove empty query parameters, as the server may not handle them rpoperly
        for (const key of Object.keys(data).filter(a => (data as any)[a] === "")) {
            delete (data as any)[key];
        }

        try {
            this.setState({
                isLoading: true
            });

            const results = await V2.post<any>(`patients/search`, data);

            this.setState({
                isLoading: false,
                results: results.results
            });

            this._tableRef.current?.querySelector<HTMLTableRowElement>("tbody > tr")?.focus();
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not search"
            });
        }
    }

    private selectPatient(id: string) {
        const patient = this.state.results.find(a => a.id === id);
        if (!patient) {
            return;
        }

        // Fix property name
        patient.chartNumber = patient.patientId;
        delete patient.patientId;

        this.props.onPatientSelected?.(id, patient);
    }

    private handleRowKeydown(e: KeyboardEvent<HTMLTableRowElement>) {
        switch (e.key) {
            case "Enter":
            case "Space":
                e.currentTarget.click();
                e.preventDefault();
                break;
            case "ArrowDown":
                (e.currentTarget.nextElementSibling as HTMLTableRowElement)?.focus();
                e.preventDefault();
                break;
            case "ArrowUp":
                (e.currentTarget.previousElementSibling as HTMLTableRowElement)?.focus();
                e.preventDefault();
                break;
            default:
                break;
        }
    }

    private clearSearchParameters() {
        this.setState({
            nameLast: "",
            nameFirst: "",
            nameMiddle: "",
            birthdate: "",
            patientId: "",
            phoneNumber: "",
            emailAddress: ""
        });
    }
}

export default withTitle("Patient Search", PatientSearchView);
